import { useCallback, useMemo } from "react"
import { Box } from "@mui/material"
import { useDropzone, DropzoneOptions } from "react-dropzone"

const baseStyle = {
	flex: 1,
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	padding: "20px 20px",
	borderWidth: 2,
	borderRadius: 2,
	borderColor: "#eeeeee",
	borderStyle: "dashed",
	backgroundColor: "#fafafa",
	color: "#545454",
	outline: "none",
	transition: "border .24s ease-in-out",
	cursor: "pointer",
}

const activeStyle = {
	borderColor: "#2196f3",
}

const acceptStyle = {
	borderColor: "#00e676",
}

const rejectStyle = {
	borderColor: "#ff1744",
}

const FileUpload = ({ onFilesRead, accept, multiple = false, disabled = false }: Props) => {
	const onDrop = useCallback(
		async (acceptedFiles: File[]) => {
			if (acceptedFiles.length > 0) {
				onFilesRead(acceptedFiles)
			}
		},
		[onFilesRead],
	)

	const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
		onDrop,
		accept,
		multiple,
	})

	const style = useMemo(
		() => ({
			...baseStyle,
			...(isDragActive ? activeStyle : {}),
			...(isDragAccept ? acceptStyle : {}),
			...(isDragReject ? rejectStyle : {}),
		}),
		[isDragActive, isDragReject, isDragAccept],
	) as any

	return (
		<Box my={2} {...getRootProps({ style })}>
			<input {...getInputProps()} disabled={disabled} />
			{isDragActive ? (
				<p>Datei hier ablegen...</p>
			) : (
				<p>Legen Sie Ihre Datei hier ab oder klicken Sie um eine Datei auszuwählen</p>
			)}
		</Box>
	)
}

interface Props {
	onFilesRead: (file: File[]) => void
	accept: DropzoneOptions["accept"]
	multiple?: boolean
	disabled?: boolean
}

export default FileUpload
